import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(homepage)/(about-us)/about-us.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(homepage)/(article)/article.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(homepage)/(blog)/blog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/vercel/path0/src/app/(homepage)/(hero)/hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(homepage)/(locations)/loc-depok.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(homepage)/(locations)/loc-kudus.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(homepage)/(reviews)/reviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Services"] */ "/vercel/path0/src/app/(homepage)/(services)/services.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Stats"] */ "/vercel/path0/src/app/(homepage)/(stats)/stats.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(homepage)/(testimonial)/testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Why"] */ "/vercel/path0/src/app/(homepage)/(why)/why.tsx");
